import PropTypes from 'prop-types';

import { evisortBlue } from '../../../assets/shared-styles/general';

const PlusIcon = ({ size = '16', color = '#FFF', opacity = '1', isActive }) => {
  const iconColor = isActive ? evisortBlue : color;
  const iconOpacity = isActive ? '1' : opacity;

  return (
    <svg width={size} height={size} viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h20v20H0z" />
        <path
          fill={iconColor}
          fillOpacity={iconOpacity}
          d="M15.833 10.833h-5v5H9.167v-5h-5V9.167h5v-5h1.666v5h5z"
        />
      </g>
    </svg>
  );
};

PlusIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.string,
  isActive: PropTypes.bool,
};

export default PlusIcon;
